import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

// rxjs
import { Subscription } from 'rxjs';

// localforage
import * as localforage from 'localforage';

// services
import { ApiService } from '@app/services/api/api.service';

@Component({
  selector: 'oh-survey-stepper',
  templateUrl: './survey-stepper.component.html',
  styleUrls: ['./survey-stepper.component.scss'],
})
export class SurveyStepperComponent implements OnInit, OnDestroy {
  private routeSubscription: Subscription;
  private data: any;
  private questions: any;
  public stepCount: number;
  public activeStep: number;

  constructor(private activatedRoute: ActivatedRoute, private apiService: ApiService) {
    this.activeStep = 1;
  }

  ngOnInit() {
    this.getData();

    this.routeSubscription = this.activatedRoute.queryParams.subscribe((params: Params) => {
      const { question } = params;
      if (question) {
        this.activeStep = parseInt(question) + 2;
      }
    });
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }

  private async getData() {
    this.data = await this.apiService.getAgentDataFromDatabase();
    this.questions = this.data.survey_questions;
    this.stepCount = this.questions.length + 1;
  }
}
